import { Button } from '@bordrio/ui-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import PresignedDownloadButton from '@src/components/PresignedDownloadButton';
import { FiscalRepSubscriptionStatusInfo } from '../../utils/order-status';

interface Props {
  statusInfo: FiscalRepSubscriptionStatusInfo;
  subscriptionId: string;
}

export default function FiscalRepActions({
  statusInfo,
  subscriptionId,
}: Props): React.JSX.Element | null {
  const { t } = useTranslation('fiscal_rep');
  const { canCancel, needsReupload, signAgreementUrl, signedContractFileId } =
    statusInfo;
  if (canCancel || needsReupload) {
    const buttonText = needsReupload
      ? t('dashboard.upload_document_button', 'Upload document')
      : t('dashboard.cancel_subscription_button', 'Cancel Subscription');

    const buttonColor = needsReupload ? undefined : 'white';

    return (
      <Link to={`/orders/fiscal-rep/request-cancellation/${subscriptionId}`}>
        <Button type="button" color={buttonColor} className="w-full sm:w-fit">
          {buttonText}
        </Button>
      </Link>
    );
  }

  if (signAgreementUrl) {
    return (
      <Link to={signAgreementUrl}>
        <Button type="button" className="w-full sm:w-fit">
          {t('dashboard.sign_agreement', 'Sign agreement')}
        </Button>
      </Link>
    );
  }

  if (signedContractFileId) {
    return (
      <PresignedDownloadButton color="white" fileId={signedContractFileId}>
        {t('dashboard.download_agreement_button', 'Download agreement')}
      </PresignedDownloadButton>
    );
  }
  return null;
}
